import { zip } from 'lodash';
export function dashify(val) {
  return val && val.length === 32 ? val.replace(/([0-9a-f]{8})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{12})/, '$1-$2-$3-$4-$5') : val;
}
export function removeDashes(id) {
  return id ? id.replace(/-/g, '') : id;
}
export const guid = () => {
  const id = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
    // eslint-disable-next-line
    const r = Math.random() * 16 | 0,
      v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  return id;
};
export function xor(str, key) {
  if (!str || !key) {
    return null;
  }
  return zip(str.split(''), key.split('')).reduce((acc, _ref) => {
    let [aStr, bStr] = _ref;
    const a = parseInt(aStr, 16);
    const b = parseInt(bStr, 16);
    if (!isNaN(a) && !isNaN(b)) {
      return acc + (a ^ b).toString(16); // eslint-disable-line no-bitwise
    }
    return acc + "-";
  }, '');
}
//# sourceMappingURL=guid.js.map